// extracted by mini-css-extract-plugin
export default {"item":"Item_item__N-G3C","anchor":"Item_anchor__No2kt","title":"Item_title__VzQ6g"};